import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Calendar } from "lucide-react";
import { content } from "../lib/i18n";
import { useLang } from "../context/LanguageContext";

const RES_IMG = `${process.env.PUBLIC_URL || ""}/brand/food-kebab-menu.jpg`;

const Reservation = () => {
  const { lang } = useLang();
  const fr = content.reserve.fr;
  const en = content.reserve.en;
  const isBoth = lang === "both";
  const data = lang === "en" ? en : fr;

  return (
    <section
      id="reservation"
      data-testid="reservation-section"
      className="bg-white section"
    >
      <div className="mx-auto max-w-[1320px] px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="lg:col-span-5 order-2 lg:order-1"
          >
            <div className="bb-img-zoom h-[280px] sm:h-[360px] lg:h-[460px] border-[3px] border-black rounded-[24px]">
              <img src={RES_IMG} alt="Big Boss menu kebab" loading="lazy" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="lg:col-span-7 order-1 lg:order-2"
          >
            <span className="eyebrow-yellow">
              <Calendar size={12} strokeWidth={2.5} />
              <span>{isBoth ? `${fr.eyebrow} · ${en.eyebrow}` : data.eyebrow}</span>
            </span>

            <h2
              data-testid="reservation-title"
              className="mt-5 h-display text-black text-[36px] sm:text-[48px] md:text-[60px] lg:text-[72px] leading-[0.95]"
            >
              <span className="block">{data.title}</span>
              <span className="block">
                <span className="inline-block mt-1 italic" style={{
                  background: "linear-gradient(transparent 60%, var(--bb-yellow) 60%)",
                  padding: "0 0.15em",
                }}>
                  {data.titleAccent}
                </span>
              </span>
            </h2>

            <p className="mt-5 text-base md:text-lg text-black/75 max-w-xl">
              {data.sub}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href={content.externalLinks.reservation}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reservation-cta-button"
                className="bb-btn bb-btn-yellow bb-btn-lg bb-btn-mobile-full"
              >
                <Calendar size={16} strokeWidth={2.5} />
                <span>{data.cta}</span>
                <ArrowUpRight size={16} strokeWidth={2.5} />
              </a>
              <span className="text-[11px] tracking-[0.22em] uppercase text-black/55 self-center font-bold">
                {lang === "en" ? "Online · 24/7 · Free" : "En ligne · 24/7 · Gratuit"}
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Reservation;
